export default __webpack_public_path__ + "static/dropdownChromeExt-43223b80ff9432894765c6e9e79687d2.png";